import React from 'react';
import PetcoIcon from '@/shared/assets/icons/logo-vetpoint-loading.svg';

import { RoundSpinnerStyled, RoundSpinnerOuterCircle, RoundSpinnerInnerCircle } from './RoundSpinner.styled';

const RoundSpinner = () => (
  <RoundSpinnerStyled>
    <RoundSpinnerOuterCircle>
      <RoundSpinnerInnerCircle />
      <PetcoIcon />
    </RoundSpinnerOuterCircle>
  </RoundSpinnerStyled>
);

export default RoundSpinner;
